<template>
  <div class="filterEvents">
    <div class="filterEvents-section">
      <div class="options-panel_head">
        <div class="s-title text-green">
          Фильтр событий
        </div>
        <p class="text-base">
          Выберите сообщения от охранной системы для отображения в списке событий. Чем больше галочек вы поставите, тем длинее будет список.
        </p>
      </div>
      <div class="style-hr__solid">
      </div>
      <div class="filterEvents-top">
        <div class="settings-operation">
          <div class="filterEvents-top_text">
            <div>
              Показать все события
            </div>
            <div class="text-small">
              Включая системные события
            </div>
          </div>
          <label class="switcher" v-on:change="changeAllEvents()">
            <input type="checkbox" v-model="filters.allEvents">
            <div class="switcher_checked">
              <div class="switcher_status">
              </div>
            </div>
            <div class="switcher_toddler">
            </div>
          </label>
        </div>
      </div>
      <perfect-scrollbar style="width: 100%">
        <div class="filterEvents-content" v-if="currentListEvent && currentListEvent.length">
					<div class="usersettings-col">
						<label class="filterEvents_item"
									 v-for="( eventItem, eventIndex ) in currentListEvent"
									 v-if="eventIndex < Math.floor( currentListEvent.length/2 )"
									 v-bind:key="eventIndex"
									 v-on:change="changeEventItem()">
							<div class="filterEvents_item-icon"
									 v-if="eventItem.id !== 205
									 		&& eventItem.id !== 226
									 		&& eventItem.id !== 218
									 		&& eventItem.id !== 219
									 		&& eventItem.id !== 200
											&& eventItem.id !== 271
											&& eventItem.id !== 267
											&& eventItem.id !== 222
											&& eventItem.id !== 213
											&& eventItem.id !== 214
											&& eventItem.id !== 216
											&& eventItem.id !== 215"
									 v-bind:style="{ 'background-image': 'url(' + require('../../assets/img/historyevent/' + eventItem.id + '.svg') + ')' }">
							</div>
							<div>
								{{eventItem.name}}
							</div>
							<div class="checkbox">
								<input type="checkbox" v-model="eventItem.active">
								<div class="checkbox_img"></div>
							</div>
						</label>
					</div>
					<div class="usersettings_separator">
					</div>
					<div class="usersettings-col">
            <label class="filterEvents_item"
                   v-for="( eventItem, eventIndex ) in currentListEvent"
                   v-if="eventIndex >= Math.floor( currentListEvent.length/2 )"
                   v-bind:key="eventIndex"
                   v-on:change="changeEventItem()">
              <div class="filterEvents_item-icon"
									 v-if="eventItem.id !== 205
									 		&& eventItem.id !== 226
									 		&& eventItem.id !== 218
									 		&& eventItem.id !== 219
									 		&& eventItem.id !== 200
											&& eventItem.id !== 271
											&& eventItem.id !== 267
											&& eventItem.id !== 222
											&& eventItem.id !== 213
											&& eventItem.id !== 215
											&& eventItem.id !== 216
											&& eventItem.id !== 214"
                   v-bind:style="{ 'background-image': 'url(' + require('../../assets/img/historyevent/'+eventItem.id+'.svg') + ')' }">
              </div>
              <div>
                {{eventItem.name}}
              </div>
              <div class="checkbox">
                <input type="checkbox" v-model="eventItem.active">
                <div class="checkbox_img"></div>
              </div>
            </label>
          </div>
        </div>
      </perfect-scrollbar>
      <div class="style-hr__solid">
      </div>
      <div class="filterEvents-bottom">
        <button type="button" class="btn btn-success" v-on:click="applyFilter()">Сохранить</button>
      </div>
    </div>
  </div>
</template>

<script>
  import { HTTP } from '../../main'

  export default {
    data(){
      return{
        filters : {
          listFormat : {
            Uni : [],
						Mobi : []
					},
          allEvents : false,
          eventsFilterUrl : 'full'
        }
      }
    },
    computed : {
      eventsFilter : function () {
        return this.$store.state.journal.filter.list
      },
      eventsUrl : function () {
        return this.$store.state.journal.filter.url
      },
			currentCar : function(){
        return this.$store.state.cars.current
      },
			currentListEvent : function () {
				let model = this.$store.state.cars.list[this.$store.state.cars.current.index].device.model;

        if (model === 1 || model === 2 || model === 3 || model === 4) {
          return this.filters.listFormat.Uni;
        } else {
          return this.filters.listFormat.Mobi;
        }
      }
    },
    mounted(){
      // Получаем список событий
      if( !this.eventsFilter.length ){
        this.getEvents();
      }

      this.filters.allEvents = this.eventsUrl === '' || this.eventsUrl === 'full';
    },
    methods : {
      getEvents : function(){
        HTTP.get('events/')
          .then( (response) => {
            let filterArr = response.data.filter((item) => {
              return item.is_event_filter
            });

            let Uni 	= this.filters.listFormat.Uni;
            let Mobi 	= this.filters.listFormat.Mobi;

            for( let i = 0; i < filterArr.length; i++ ){
              let item = filterArr[i];
							this.$set( item, 'active', true );

              if(  item.device_models.indexOf(1) > -1
                || item.device_models.indexOf(2) > -1
                || item.device_models.indexOf(3) > -1
                || item.device_models.indexOf(4) > -1 ){
                Uni.push( item );
              }
              if(
                item.device_models.indexOf(13) > -1
                || item.device_models.indexOf(14) > -1 ){
                Mobi.push( item );
              }
            }
          }).catch( ( error ) => {
          this.$store.dispatch('errorResponse', error );
        });
			},
      changeAllEvents : function () {
        if( this.filters.allEvents === true ){
          for( let i = 0; i < this.currentListEvent.length; i++ ){
            this.currentListEvent[i].active = true;
            this.filters.eventsFilterUrl = 'full';
          }
        }else{
          for( let i = 0; i < this.currentListEvent.length; i++ ){
            this.currentListEvent[i].active = false;
            this.filters.eventsFilterUrl = 'empty';
          }
        }
      },
      changeEventItem : function () {
        let count = 0;

        // Показать все
        if( this.filters.allEvents === true ){
          this.filters.allEvents = false;
        }

        // Смотрим какие выбрали и собираем ссылку
        this.filters.eventsFilterUrl = '';
        for( let i = 0; i < this.currentListEvent.length; i++ ){
          if( this.currentListEvent[i].active === true ){
            this.filters.eventsFilterUrl += '&eid=' + this.currentListEvent[i].id;
            count += 1;
          }
        }

        // Проверяем заполненый/пустые ли все
        if( count === this.currentListEvent.length ){
          this.filters.allEvents = true;
          this.filters.eventsFilterUrl = 'full';
        }else if( count === 0 ){
          this.filters.eventsFilterUrl = 'empty'
        }
      },

      applyFilter : function () {
        this.$store.dispatch( 'saveEventsFilter', this.filters );
        this.$store.dispatch( 'addAlert', { text : 'Фильтр изменен', type : 'success' });
        this.$store.dispatch( 'optionPanel', 0 );
      },
    },
  }
</script>